import { Box } from '@chakra-ui/react';
import NewsBanner from './news-banner';
import TopBanner from './top-banner';

export default function BannerDashboard() {
  return (
    <Box spaceY={'8'}>
      <TopBanner />
      <NewsBanner />
    </Box>
  );
}
